module.exports = __webpack_public_path__ + "static/media/supportLogo2.9e018e7b.svg";